import React from 'react';

export default function AccessManagement() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>Access Management</h2>
      <p style={{ color: '#666', marginTop: 20 }}>This feature is currently under maintenance.</p>
    </div>
  );
}

// DISABLED - Original implementation commented out
// import React, { useState, useEffect } from 'react';
// import '../styles/AccessManagement.css';

// const AVAILABLE_PERMISSIONS = [
//   { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
//   { id: 'rubrics', label: 'Rubrics', icon: '📋' },
//   { id: 'sheets', label: 'Sheets', icon: '📄' },
//   { id: 'tables', label: 'Tables', icon: '📊' },
//   { id: 'students', label: 'Students', icon: '👥' },
//   { id: 'scans', label: 'Scans', icon: '📁' }
// ];

// export default function AccessManagement() {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState({ text: '', type: '' });
//   const [changes, setChanges] = useState({}); // Track changes per user

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     setLoading(true);
//     setMessage({ text: '', type: '' });
    
//     try {
//       const token = localStorage.getItem('authToken');
//       const response = await fetch(`${window.API_BASE_URL}/users/permissions/all`, {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setUsers(data.users || []);
//         setChanges({}); // Reset changes when loading fresh data
//       } else {
//         throw new Error('Failed to fetch users');
//       }
//     } catch (err) {
//       setMessage({ text: 'Failed to load users', type: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const togglePermission = (userId, permission) => {
//     setUsers(prevUsers => {
//       const updated = prevUsers.map(user => {
//         if (user.id === userId) {
//           const hasPermission = user.permissions.includes(permission);
//           const newPermissions = hasPermission
//             ? user.permissions.filter(p => p !== permission)
//             : [...user.permissions, permission];
          
//           return { ...user, permissions: newPermissions };
//         }
//         return user;
//       });
      
//       // Mark this user as changed
//       setChanges(prev => ({ ...prev, [userId]: true }));
      
//       return updated;
//     });
//   };

//   const saveChanges = async () => {
//     setLoading(true);
//     setMessage({ text: '', type: '' });

//     try {
//       const token = localStorage.getItem('authToken');
//       const changedUserIds = Object.keys(changes);
      
//       if (changedUserIds.length === 0) {
//         setMessage({ text: 'No changes to save', type: 'info' });
//         setLoading(false);
//         return;
//       }

//       // Save each changed user's permissions
//       for (const userId of changedUserIds) {
//         const user = users.find(u => u.id === parseInt(userId));
//         if (!user) continue;

//         const response = await fetch(`${window.API_BASE_URL}/users/${userId}/permissions`, {
//           method: 'PUT',
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//           },
//           body: JSON.stringify({
//             permissions: user.permissions
//           })
//         });

//         if (!response.ok) {
//           throw new Error(`Failed to update permissions for ${user.full_name}`);
//         }
//       }

//       setMessage({ text: `Successfully updated permissions for ${changedUserIds.length} user(s)`, type: 'success' });
//       setChanges({}); // Clear changes after successful save
//     } catch (err) {
//       setMessage({ text: err.message || 'Failed to save changes', type: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetChanges = () => {
//     fetchUsers(); // Reload from server
//   };

//   return (
//     <div className="access-management">
//       <div className="access-header">
//         <h2>Access Management</h2>
//         <p>Control which tabs each user can access</p>
//       </div>

//       {/* Messages */}
//       {message.text && (
//         <div className={`message ${message.type}-message`}>
//           {message.text}
//         </div>
//       )}

//       {/* Action Buttons */}
//       <div className="access-actions">
//         <button 
//           className="btn-save" 
//           onClick={saveChanges}
//           disabled={loading || Object.keys(changes).length === 0}
//         >
//           <i className="fas fa-save" aria-hidden="true"></i> Save Changes
//           {Object.keys(changes).length > 0 && ` (${Object.keys(changes).length})`}
//         </button>
//         <button 
//           className="btn-reset" 
//           onClick={resetChanges}
//           disabled={loading || Object.keys(changes).length === 0}
//         >
//           <i className="fas fa-undo" aria-hidden="true"></i> Reset
//         </button>
//       </div>

//       {/* Users Table */}
//       {loading ? (
//         <div className="loading">Loading users...</div>
//       ) : users.length === 0 ? (
//         <div className="no-data">No users found</div>
//       ) : (
//         <div className="access-table-wrapper">
//           <table className="access-table">
//             <thead>
//               <tr>
//                 <th className="col-name">Name</th>
//                 <th className="col-role">Role</th>
//                 {AVAILABLE_PERMISSIONS.map(perm => (
//                   <th key={perm.id} className="col-permission" title={perm.label}>
//                     <span className="permission-label">{perm.label}</span>
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {users.map(user => (
//                 <tr key={user.id} className={changes[user.id] ? 'changed' : ''}>
//                   <td className="col-name">
//                     <div className="user-name">{user.full_name}</div>
//                     <div className="user-username">@{user.username}</div>
//                   </td>
//                   <td className="col-role">
//                     <span className={`role-badge role-${user.role}`}>
//                       {user.role}
//                     </span>
//                   </td>
//                   {AVAILABLE_PERMISSIONS.map(perm => (
//                     <td key={perm.id} className="col-permission">
//                       <label className="checkbox-container">
//                         <input
//                           type="checkbox"
//                           checked={user.permissions.includes(perm.id)}
//                           onChange={() => togglePermission(user.id, perm.id)}
//                         />
//                         <span className="checkmark"></span>
//                       </label>
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Legend */}
//       <div className="access-legend">
//         <h4>Legend:</h4>
//         <div className="legend-items">
//           {AVAILABLE_PERMISSIONS.map(perm => (
//             <span key={perm.id} className="legend-item">
//               {perm.icon} {perm.label}
//             </span>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
